import React, {useLayoutEffect,useState } from 'react';
import { RUN_TIME_API_ENDPOINT, GetCurrentUserRoles, CommonHeaderOption } from "../common/common";
import { downloadCSV, Title } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';

const BulkOrderBlockUpload = () => {
    
    const [fileExtError, setFileExtError] = useState(false);
    const [sizeError, setSizeError] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    // const [dataUpload, setDataUpload] = useState([]);
    const [showModal, setMoadalVisible] = useState(false)
    const [message,setMessage]=useState('');

    useLayoutEffect(() => {
        const roleData = GetCurrentUserRoles();
        if (["$csa", "$ca"].indexOf(roleData[0]) === -1) {
            window.location.replace(window.location.origin + "/#/madagascar_products_list")
        }      
    }, []);

    
    const handleImageChange = (e) => {
        e.preventDefault();
        const selectedFile = this.inputImgElement.files;
        const fileExtention = selectedFile && selectedFile[0].name.substring(selectedFile[0].name.lastIndexOf('.') + 1);
        console.log('fileExtention', fileExtention, selectedFile[0]);

        const maxSize = 10;

        if (((selectedFile[0].size / 1024 / 1024) > maxSize)) {
           
            setFileExtError(false);
            setSizeError(true);
        } else if ('csv' !== fileExtention) {
            
            setFileExtError(true);
            setSizeError(false);
        } else {
            setFileExtError(false);
            setSizeError(false);
            setSelectedFile(e?.target?.files[0])
        }
    }

    const onSave = () => {
        
        setShowLoader(true);
        const formData = new FormData();

        // Update the formData object 
        formData.append('files', selectedFile);
        formData.append('file_name', selectedFile.name);

        const stateData = localStorage.getItem('__state');
        const userData = stateData ? JSON.parse(stateData) : false;
        const options = {}
        options.method = "POST";
        options.headers = {
            'Authorization': userData._token,
        }
        options.body = formData;

        const url = `${RUN_TIME_API_ENDPOINT}/businesses/update_ordering_block_csv`;
        fetch(url, options)
            .then(res => {
                if (res.status === 401) {
                    // localStorage.removeItem("__state");
                    window.location.href = "#/login";
                }
                return res.json();
            })
            .then(json => {
                console.log('json==>', json);
                // const msg = '';
                const msg = json.data ? json.data[0].message : '';
                Swal.fire({
                    html: msg,
                    icon: 'success',
                }).then((result) => {
                    if (result.isConfirmed) {
                        setShowLoader(false);
                        window.location.href = '#';
                    }
                })
                setMessage(msg);

            }).catch(error => {
                setMessage('Something went wrong. Please try again.');

                Swal.fire({
                    html: 'Something went wrong. Please try again.',
                    icon: 'error',
                }).then((result) => {
                    if (result.isConfirmed) {
                        setShowLoader(false);

                    }
                })
            });

    }
    const onModalClose = () => {
        setMoadalVisible(false);
        window.location.replace(window.location.origin + "/#/madagascar_products_list")
    }

    const callExport = (e) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        options.method = 'GET';
        fetch(`${apiUrl}/madagascar_products_list?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B%22id%22%2C%22DESC%22%5D`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                const prodList = jsonD.data;
                const csv = convertToCSV({
                    "fields": ['name', 'client_category_code', 'material_number', 'material_description', 'price_after_tax', 'status'],
                    "data": prodList
                });
                downloadCSV(csv, 'product_price_list');
            }
            );
    }

        const { state} = this;
        return (
            <React.Fragment>
                <center><Title title="Ordering Blocked Upload" /></center>
                <div className="target-upload-container">
                    <label>Upload File</label>
                    <input
                        type="file"
                        accept=".csv"
                        name="flies[]"
                        ref={(inputFileImg) => { this.inputImgElement = inputFileImg; }}
                        onChange={handleImageChange}
                    />
                    {
                        (fileExtError || sizeError) &&

                        <div className="valid-file-upload-error">
                            {
                                fileExtError &&
                                <p>File type must be .csv</p>
                            }
                            {
                               sizeError &&
                                <p>File size must be less than 10 MB</p>
                            }
                        </div>
                    }
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Only CSV files are allowed.</li>
                            <li>File size should be less than 2 MB.</li>
                            <li>Please wait for the file upload to complete and for the confirmation message to appear before moving away from this page.</li>
                            <li>You will receive the results of the upload via email indicating how many records were added, updated and failed (if any).</li>
                        </ul>
                    </div>
                    <div className="upload-file-format-download">
                        <p>To get upload file format. <a href="https://navendor-global-production.s3.eu-west-1.amazonaws.com/fille_formats/order_blocked_format.csv" target="_blank" >Click here</a> to download</p>
                    </div>
                    {
                        showLoader &&
                        <div className="login-loader" />
                    }
                    {
                        !showLoader &&
                        <div className="so-save-button">
                            <button onClick={onSave} disabled={!selectedFile}>Save</button>
                        </div>
                    }
                    {
                        showModal &&
                        <Modal open={showModal} onClose={onModalClose} center>
                            <h3>{message}</h3>
                        </Modal>
                    }
                </div>
            </React.Fragment>
        )
    
}

export default BulkOrderBlockUpload;